<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'families.create'}"><i class="fa fa-plus"></i> Criar</router-link>
      <router-link class="btn btn-primary" :to="{name:'families.import'}"><i class="fa fa-plus"></i> Importar</router-link>
      <b-button class="btn btn-primary" @click="exportGrid()" ><i class="fa fa-download"></i> Exportar</b-button>
      <b-button class="btn btn-primary" @click="showModal()" >Cancelar famílias</b-button>
    </div>
    <grid ref="familiesGrid" name="familiesGridPaginated"  height="calc(100vh - 250px)" :preload="preload" :editable="true" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></grid>
  </b-card>
  <b-modal id="disable-families" hide-footer>
    <template v-slot:modal-title>
      Inactivar famílias que não pagaram quotas
    </template>
    <div class="d-block ">
      <p>Desactivar todas as famílias que não pagaram quota do ano:</p>
      <b-form-fieldset label="Ano">
        <b-form-input type="number" step="1" name="year" v-model="disableYear" placeholder="Ano" v-validate="{ required: true }" ></b-form-input>
        <b-form-invalid-feedback>
          {{ errors.first('year') }}
        </b-form-invalid-feedback>
      </b-form-fieldset>
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('create-mb')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="disableFamilies()">Continuar</b-button>
  </b-modal>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import States from '@/components/Lists.js'
import router from '@/router'

export default {
  name: 'FamiliesGrid',
  components: {
    Grid
  },
  data() {
    return {
      exporting: false,
      fileDownload: {
        url: '',
        title: ''
      },
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        },
        'membership_type_id': {
          type: 'number',
          editable: true
        },
        'number_members': {
          type: 'number',
          editable: false
        },
        'firstFeeYear': {
          type: 'number',
          editable: false
        },
        'latestFeeYear': {
          type: 'number',
          editable: false
        },
        'year_started': {
          type: 'number',
          editable: false
        },
        'new_family': {
          type: 'number',
          editable: false
        },
        'code': {
          type: 'number',
          editable: false
        }
      },
      url: 'families/paginated',
      preload: [{
        api: 'regions/lst',
        field: 'region_id'
      }, {
        api: 'membershiptypes/lst',
        field: 'membership_type_id'
      }, {
        api: 'countries/lst',
        field: 'country_id'
      }],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '80px',
        locked: true
      },
      {
        field: 'code',
        title: 'ID Família',
        width: '90px',
        editable: false,
        locked: true
      },
      {
        field: 'surname',
        title: 'Apelido',
        width: '180px',
        locked: true
      },
      {
        field: 'latestFeeYear',
        title: 'Última Quota',
        width: '180px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '180px',
        locked: false,
        values: States.states
      },
      {
        field: 'address',
        title: 'Morada',
        width: '180px'
      },
      {
        field: 'zip_code',
        title: 'Código Postal',
        width: '180px'
      },
      {
        field: 'locality',
        title: 'Localidade',
        width: '180px'
      },
      {
        field: 'country_id',
        title: 'País',
        width: '180px'
      },
      {
        field: 'region_id',
        title: 'Código de Zona',
        width: '180px'
      },
      {
        field: 'phone',
        title: 'Contacto Telefónico',
        width: '180px'
      },
      {
        field: 'email',
        title: 'Email',
        width: '180px'
      },
      {
        field: 'notes',
        title: 'Observações',
        width: '180px'
      },
      {
        field: 'membership_type_id',
        title: 'Tipo de Sócio',
        width: '180px',
        attributes: {
          "class": 'membership-type'
        }
      },
      {
        field: 'year_started',
        title: 'Ano inscrição',
        width: '180px'
      },
      {
        field: 'firstFeeYear',
        title: 'Primeira Quota',
        width: '180px'
      },
      {
        field: 'number_members',
        title: 'Nº Total da Família',
        width: '180px'
      },
      {
        field: 'new_family',
        title: 'Novo sócio',
        width: '180px',
        values: States.yesNo
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }],
      disableYear: null
    }
  },
  methods: {
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    exportGrid: function() {
      this.exporting = true
      var grid = this.$refs.familiesGrid.$refs.mygrid.kendoWidget()
      console.log(grid.getOptions())
      this.axios.post('families/export', {
        filter: grid.getOptions().dataSource.filter
      }).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    },
    showModal() {
       this.$bvModal.show('disable-families')
    },
    disableFamilies() {
      let data = { year: this.disableYear }
      this.axios.post('families/disable', data ).then(response => {
        this.$bvToast.toast('foram desactivadas ' + response.data.data + ' famílias', { autoHideDelay: 5000, variant: 'success', solid: true})
         this.$bvModal.hide('disable-families')
      })
    },
    cellFunction: function (h, tdElement , props, listeners ) {
        return h('td', {
            on: {
                click: function(e){
                    listeners.custom(e);
                }
            }
        }, ['custom ' + props.dataItem.UnitPrice]);
    },
    getBtnTemplate: function(item) {
      if (this.$auth.check('families.edit')) {
        var route = router.resolve({
          name: 'families.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      } else if (this.$auth.check('families.view')) {
        var route = router.resolve({
          name: 'families.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i></a>'
      }
      return ''
    }
  }
}
</script>

